import { motion } from "framer-motion";
import { IconCall, IconEmail, IconLocation, Logo } from "../../Icons/Icon";
import { useDispatch, useSelector } from "react-redux";
import {  useEffect } from "react";
import { fetchContactsData } from "../../features/Setting/contact";
import { useTranslation } from "react-i18next";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 120 },
  },
};

const iconHover = {
  hover: { scale: 1.1, rotate: -5 },
  tap: { scale: 0.95 },
};

function Contact() {
  const dispatch = useDispatch();
  const { contacts } = useSelector((state) => state.settingContact);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch(fetchContactsData());
  }, [dispatch, i18n.language]);

  return (
    <motion.div
      className="flex flex-col md:flex-row gap-8 items-center p-6 bg-white  shadow-lg"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div
        variants={itemVariants}
        whileHover={{ scale: 1.05 }}
        className=" md:w-1/3 flex justify-center"
      >
        <Logo width={"w-32  md:w-52"} height={"h-32 md:h-52"} />
      </motion.div>

      <motion.div
        className="flex flex-col gap-6 w-full md:w-2/3"
        variants={containerVariants}
      >
        {/* Email */}
        <motion.div
          className="flex flex-col gap-2 p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-colors"
          variants={itemVariants}
          whileHover={{ x: 10 }}
        >
          <div className="flex items-center gap-3">
            <motion.div
              variants={iconHover}
              whileHover="hover"
              whileTap="tap"
              className="text-green-600"
            >
              <IconEmail className="w-6 h-6" />
            </motion.div>
            <h3 className="text-lg font-semibold text-gray-700">
              {t("email")}
            </h3>
          </div>
          <p className="text-gray-600 pl-9">
            {contacts?.find((setting) => setting.key === "email")?.value ||
              "N/A"}
          </p>
        </motion.div>

        {/* Location */}
        {contacts?.find((setting) => setting.key === "location")?.value && (
          <motion.div
            className="flex flex-col gap-2 p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-colors"
            variants={itemVariants}
            whileHover={{ x: 10 }}
          >
            <div className="flex items-center gap-3">
              <motion.div
                variants={iconHover}
                whileHover="hover"
                whileTap="tap"
                className="text-green-600"
              >
                <IconLocation className="w-6 h-6" />
              </motion.div>
              <h3 className="text-lg font-semibold text-gray-700">
                {t("Location")}
              </h3>
            </div>
            <p className="text-gray-600 pl-9">
              {contacts?.find((setting) => setting.key === "location")?.value ||
                "N/A"}
            </p>
          </motion.div>
        )}

        {/* Phone */}
        <motion.div
          className="flex flex-col gap-2 p-4 bg-gray-50 rounded-xl hover:bg-green-50 transition-colors"
          variants={itemVariants}
          whileHover={{ x: 10 }}
        >
          <div className="flex items-center gap-3">
            <motion.div
              variants={iconHover}
              whileHover="hover"
              whileTap="tap"
              className="text-green-600"
            >
              <IconCall className="w-6 h-6" />
            </motion.div>
            <h3 className="text-lg font-semibold text-gray-700">
              {t("phone")}
            </h3>
          </div>
          <p className="text-gray-600 pl-9">
            {contacts?.find((setting) => setting.key === "phone")?.value ||
              "N/A"}
          </p>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default Contact;
